import script from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__